import { Box, Typography } from '@mui/material';
import { ReactComponent as ErrorIcon } from '../../../assests/svg/error-icon.svg';
import { t } from 'i18next';
import AurTooltip from '../../common/aur-tooltip/AurTooltip';
import AurIcon, {IconNames} from '../../common/aur-icon/AurIcon';
import { EvidenceStatuses } from '../../../constants/constants';
import { getEvidenceStatusString, getEvidenceSubStatusString, getEvidenceTooltipString } from './evidenceStatusHelper';

interface StatusProps {
  status?: string;
  subStatus?: string;
}

const EvidenceStatus: React.FC<StatusProps> = ({ status, subStatus }) => {
  let txtClass = '';
  let subStatusAbove = false;
  let tooltipMessage = '';
  let showInfoIcon = false;

  switch (status) {
    case EvidenceStatuses.IN_PROCESSING:
    case EvidenceStatuses.PENDING_APPROVAL:
      txtClass = 'processing-status';
      showInfoIcon = false;
      tooltipMessage = t('evidenceSource.tooltip.intakeBatching');
      break;

    case EvidenceStatuses.MAPPING_DATA:
      txtClass = 'processing-status';
      break;

    case EvidenceStatuses.PROCESSED:
    case EvidenceStatuses.MAPPING_COMPLETE:
      txtClass = 'processed-status';
      break;

    case EvidenceStatuses.PROCESSED_WITH:
      txtClass = 'mapping-status';
      break;

    case EvidenceStatuses.PROCESSING_FAILED:
      txtClass = 'failed-status';
      tooltipMessage = t('evidenceSource.tooltip.processingFailed');
      break;

    // -------- Intake Sub Flow --------
    case EvidenceStatuses.INTAKE_DATA_COPYING:
      subStatusAbove = true;
      showInfoIcon = true;
      tooltipMessage = getEvidenceTooltipString(status);
      break;

    case EvidenceStatuses.INTAKE_Extraction:
      subStatusAbove = true;
      showInfoIcon = true;
      tooltipMessage = getEvidenceTooltipString(status);
      break;

    case EvidenceStatuses.INTAKE_VIRUS_SCANNING:
      subStatusAbove = true;
      showInfoIcon = true;
      tooltipMessage = getEvidenceTooltipString(status);
      break;

    case EvidenceStatuses.INTAKE_COPY_TO_OUTPUT:
      subStatusAbove = true;
      showInfoIcon = true;
      tooltipMessage = getEvidenceTooltipString(status);
      break;

    case EvidenceStatuses.INTAKE_BEING_PARSED:
      subStatusAbove = true;
      showInfoIcon = true;
      tooltipMessage = getEvidenceTooltipString(status);
      break;

    case EvidenceStatuses.INTAKE_BATCHING:
      subStatusAbove = true;
      showInfoIcon = true;
      tooltipMessage = getEvidenceTooltipString(status);
      break;

    case EvidenceStatuses.INTAKE_PENDING:
      subStatusAbove = true;
      break;

    case EvidenceStatuses.IN_PROCESSING_MANUAL:
      showInfoIcon = true;
      subStatusAbove = false;
      txtClass = 'processing-status';
      tooltipMessage = getEvidenceTooltipString(status);
      break;

    default:
      break;
  }
  const subStatusBelowString = () => {
    if (status === EvidenceStatuses.STAGED) return 'STAGED_FOR_PROCESSING';
    else if (status === EvidenceStatuses.IN_PROCESSING_MANUAL)
      return 'IN_PROCESSING_MANUAL';
    return '';
  };
  return (
    <Box className="evidence-status">
      <div className="text-container">
        {subStatusAbove && subStatus && (
          <Typography className="subtitle" >
            <span tabIndex={0}>
             {getEvidenceSubStatusString(subStatus)}
            </span>
          </Typography>
        )}

        {status && (
          <Typography
            noWrap
            title={getEvidenceStatusString(status)}
            className={`status typo-text body3_size ${txtClass}`}
          >
            <span tabIndex={0}>
              {getEvidenceStatusString(status)}
            </span>
          </Typography>
        )}

        {!subStatusAbove && subStatusBelowString() && (
          <Typography className="subtitle">
            <span tabIndex={0}>
              {getEvidenceSubStatusString(subStatusBelowString())}
            </span>
          </Typography>
        )}
      </div>

      {status === EvidenceStatuses.PROCESSING_FAILED && (
        <AurTooltip
          title={tooltipMessage}
          aria-label={tooltipMessage}
          className="typo-text tooltipMessage_size"
          trigger='click'
        >
          <ErrorIcon tabIndex={0} />
        </AurTooltip>
      )}

      {showInfoIcon && (
        <AurTooltip
          title={tooltipMessage}
          className="typo-text tooltipMessage_size"
          trigger='click'
        >
          <div className='icon-container' tabIndex={0} data-testid="info-icon">
            <AurIcon icon={IconNames.Info} />
          </div>
        </AurTooltip>
      )}
    </Box>
  );
};

export default EvidenceStatus;
